"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", { value: true });
exports.getIsNativeError = exports.getDeviceName = exports.getOperatingSystem = exports.computeS = exports.computeModPow = void 0;
var computeModPow_1 = require("./computeModPow");
Object.defineProperty(exports, "computeModPow", { enumerable: true, get: function () { return computeModPow_1.computeModPow; } });
var computeS_1 = require("./computeS");
Object.defineProperty(exports, "computeS", { enumerable: true, get: function () { return computeS_1.computeS; } });
var getOperatingSystem_1 = require("./getOperatingSystem");
Object.defineProperty(exports, "getOperatingSystem", { enumerable: true, get: function () { return getOperatingSystem_1.getOperatingSystem; } });
var getDeviceName_1 = require("./getDeviceName");
Object.defineProperty(exports, "getDeviceName", { enumerable: true, get: function () { return getDeviceName_1.getDeviceName; } });
var getIsNativeError_1 = require("./getIsNativeError");
Object.defineProperty(exports, "getIsNativeError", { enumerable: true, get: function () { return getIsNativeError_1.getIsNativeError; } });
